module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921045651_T.2537aa0d.jpg";